import createField from '../../utils/factory/createField';

export const loginFields = [
    createField({
        id: 'username',
        type: 'text',
        placeholder: "Insira seu usuário", 
        handleChange: 'handleChange',
        fullWidth: true
    }),
    createField({
        id: 'password',
        type: 'password',
        placeholder: "Insira sua senha", 
        handleChange: 'handleChange',
        fullWidth: true
    })
];
